// extracted by mini-css-extract-plugin
export default {"text":"HoverText_text__OFQKu"};